<template>
  <div>
    <Notification :text="$t('message.credit.notification')"> </Notification>
    <CreditResultDetails
      class="mt-4"
      :creditVisionScore="creditVisionScore"
      :tradeLines="$store.state.credit.tradeLines"
    >
    </CreditResultDetails>
    <ApplyNow></ApplyNow>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CreditResultDetails from '@/components/credit-results/CreditResultDetails.vue';
import ApplyNow from '@/components/credit/ApplyNow.vue';
import Notification from '@/components/shared/Notification.vue';

export default {
  name: 'TUCreditResults',
  components: {
    ApplyNow,
    CreditResultDetails,
    Notification,
  },
  computed: {
    ...mapGetters('credit', ['creditVisionScore']),
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables';
</style>
